import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormGroup, FormControl, Validators, FormControlName} from '@angular/forms';
import { numberValidator } from 'src/app/_validators';
import { ActualizacionDatosService } from '../actualizacion-datos.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-datos-ubicacion',
  standalone: false,
  templateUrl: './datos-ubicacion.component.html',
  styleUrls: ['./datos-ubicacion.component.scss', '../actualizacion_datos.scss']
})
export class DatosUbicacionComponent implements OnInit {

  @Input()
  datosUbicacionForm: UntypedFormGroup;

  tipos: any[] = [
    {value: 'steak-0', viewValue: 'Steak'},
    {value: 'pizza-1', viewValue: 'Pizza'},
    {value: 'tacos-2', viewValue: 'Tacos'}
  ];

  public ciudades$: Observable<any>;

  constructor(private actualizacionService: ActualizacionDatosService) { }

  ngOnInit() {
    this.ciudades$ = this.actualizacionService.ciudades$;
  }

  getErrorMessage(controlPath: string) {
    const control = this.datosUbicacionForm.get(controlPath);
    return control.hasError('required') ? 'Este campo es requerido' :
        control.hasError('email') ? 'No es un email valido' :
        control.hasError('invalidNumber') ? 'No es un número valido' :
        control.hasError('invalidPhone') ? 'No es un número de telephono valido' :
            '';
  }

}
